module.exports = __webpack_public_path__ + "static/img/end.0ccf685b.png";